import { Component, Input, OnInit } from '@angular/core';
import { IParceiroContato } from '@app/modules/parceiro/model';
import {
  IConsultaPredictusPessoaJuridica,
  MOCK_PESSOA_JURIDICA
} from '@app/modules/parceiro/model/consulta_predictus_pj.model';

@Component({
  selector: 'info-predictus-pj',
  templateUrl: './info-predictus-pj.component.html',
  styleUrl: './info-predictus-pj.component.scss'
})
export class InfoPredictusPjComponent implements OnInit {
  @Input()
  pessoaJuridica = MOCK_PESSOA_JURIDICA as IConsultaPredictusPessoaJuridica;

  ngOnInit() {
    this.pessoaJuridica.contatos = this.pessoaJuridica.contatos
      .concat(
        this.pessoaJuridica.telefones.map((tel, index) => {
          return {
            contato: tel.numero ? tel.numero : tel,
            tag: `telefone_${index + 1}`
          } as IParceiroContato;
        })
      )
      .concat(
        this.pessoaJuridica.emails.map((mail, index) => {
          return {
            contato: mail,
            tag: `email_${index + 1}`
          } as IParceiroContato;
        })
      );
  }

  /**
   * Formata uma tag para ser mostrada na view
   * @param tag tag a ser formatada
   */
  formatarTags(tag: string[]): string[] {
    if (typeof tag === 'object') return tag.filter(tg => tg !== '');
    else return tag;
  }
}
